var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarActive2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1819_152718)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9353 32.0571C19.5566 32.0571 19.2389 31.9288 18.9823 31.6722C18.7266 31.4165 18.5987 31.0993 18.5987 30.7206V29.1836C17.5964 28.9609 16.7165 28.571 15.9591 28.0142C15.2018 27.4573 14.5892 26.6777 14.1215 25.6753C13.9655 25.3634 13.9597 25.0351 14.1041 24.6903C14.2493 24.3446 14.5113 24.0937 14.8899 23.9378C15.2018 23.8042 15.5248 23.81 15.8589 23.9552C16.193 24.0995 16.4492 24.3388 16.6274 24.6729C17.0061 25.3412 17.485 25.8481 18.0641 26.1938C18.6433 26.5387 19.3561 26.7111 20.2026 26.7111C21.1158 26.7111 21.8901 26.5052 22.5254 26.0936C23.1598 25.6811 23.477 25.0404 23.477 24.1717C23.477 23.3921 23.232 22.7737 22.7419 22.3166C22.2519 21.8604 21.1158 21.3428 19.3338 20.7636C17.4182 20.1622 16.1039 19.444 15.3911 18.6092C14.6783 17.7734 14.3219 16.7541 14.3219 15.5513C14.3219 14.1034 14.7897 12.9785 15.7253 12.1766C16.6608 11.3747 17.6186 10.918 18.5987 10.8067V9.3365C18.5987 8.95783 18.7266 8.64019 18.9823 8.38358C19.2389 8.12786 19.5566 8 19.9353 8C20.3139 8 20.6316 8.12786 20.8882 8.38358C21.1439 8.64019 21.2718 8.95783 21.2718 9.3365V10.8067C22.1182 10.9403 22.8533 11.2134 23.477 11.6259C24.1007 12.0376 24.613 12.5441 25.014 13.1455C25.2144 13.4351 25.2537 13.7581 25.1316 14.1145C25.0086 14.4709 24.7578 14.7271 24.3791 14.883C24.0673 15.0167 23.7443 15.022 23.4102 14.899C23.076 14.777 22.7642 14.56 22.4746 14.2482C22.185 13.9363 21.8456 13.6966 21.4562 13.5291C21.0659 13.3625 20.5812 13.2792 20.0021 13.2792C19.022 13.2792 18.2758 13.4966 17.7634 13.9314C17.2511 14.3653 16.9949 14.9053 16.9949 15.5513C16.9949 16.2863 17.3291 16.8655 17.9973 17.2887C18.6656 17.7119 19.8239 18.1574 21.4722 18.6252C23.0092 19.0707 24.1733 19.7777 24.9645 20.7462C25.7548 21.7157 26.15 22.8352 26.15 24.1049C26.15 25.6864 25.6822 26.8893 24.7467 27.7134C23.8111 28.5376 22.6528 29.05 21.2718 29.2504V30.7206C21.2718 31.0993 21.1439 31.4165 20.8882 31.6722C20.6316 31.9288 20.3139 32.0571 19.9353 32.0571Z",
    fill: "url(#paint1_linear_1819_152718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1819_152718",
    x1: 40,
    y1: 20,
    x2: -0.00000136342,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1819_152718",
    x1: 26.15,
    y1: 20.0286,
    x2: 14,
    y2: 20.0286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarActive2);
export default __webpack_public_path__ + "static/media/DollarActive2.8c00f6960416fe488542b6e2b1543a1f.svg";
export { ForwardRef as ReactComponent };